import React from 'react';
import { Row, Col, Card, Typography, Tag } from 'antd';
import { 
  CloudOutlined, 
  RobotOutlined, 
  DatabaseOutlined, 
  SyncOutlined 
} from '@ant-design/icons';
import { services } from '../data/mockData';

const { Title, Paragraph } = Typography;

const iconMap = {
  cloud: CloudOutlined,
  robot: RobotOutlined,
  database: DatabaseOutlined,
  transformation: SyncOutlined
};

const ServicesSection = () => {
  return (
    <div className="section-padding" style={{ background: '#f8fafe' }}>
      <div className="container">
        <Title className="section-title" style={{ color: '#1a1a1a', fontSize: '3rem', marginBottom: '1rem' }}>我们的服务</Title>
        <Paragraph className="section-subtitle" style={{ fontSize: '1.2rem', color: '#666', marginBottom: '4rem' }}>
          为企业提供全方位的云智能解决方案，助力数字化转型升级
        </Paragraph>
        
        <Row gutter={[24, 24]}>
          {services.map(service => {
            const IconComponent = iconMap[service.icon];
            return (
              <Col xs={24} sm={12} lg={6} key={service.id}>
                <Card 
                  className="service-card" 
                  hoverable
                  style={{ 
                    borderRadius: '16px', 
                    border: 'none',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                    height: '100%',
                    background: 'white'
                  }}
                >
                  <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                    <IconComponent style={{ fontSize: '4rem', color: '#1890ff', marginBottom: '1.5rem' }} />
                    <Title level={4} style={{ fontSize: '1.4rem', fontWeight: '600', marginBottom: '1rem', color: '#1a1a1a' }}>
                      {service.title}
                    </Title>
                    <Paragraph style={{ color: '#666', lineHeight: '1.7', marginBottom: '2rem', fontSize: '0.95rem' }}>
                      {service.description}
                    </Paragraph>
                    <div>
                      {service.features.map(feature => (
                        <Tag 
                          key={feature} 
                          style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '20px',
                            padding: '6px 16px',
                            margin: '4px',
                            fontSize: '0.9rem'
                          }}
                        >
                          {feature}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default ServicesSection;